"use client"

import React, { createContext, useContext, useEffect, useState } from "react"

import {Branch, Brand, BrandTheme} from "@/types/popadvise"
import useLocalStorage from "@/hooks/use-local-storage"

type FormContextType = {
    brand: Brand
    currentBranch: Branch
    setCurrentBranch: React.Dispatch<React.SetStateAction<Branch>>
    theme: BrandTheme
}

const FormContext = createContext<null | FormContextType>(null)

export const CurrentBranchProvider = ({ brand, children }: { 
    brand: Brand
    children: React.ReactNode
}) => {
    const [localBranchId, setLocalBranchId] = useLocalStorage<string>("currentBranchId", brand.branches[0].id)
    const [currentBranch, setCurrentBranch] = useState<Branch>(
        brand.branches.find(branch => branch.id === localBranchId) ||
        brand.branches[0]
    )
    const [theme] = useState<BrandTheme>(brand.theme)

    useEffect(() => {
        setLocalBranchId(currentBranch.id)
    }, [currentBranch, setLocalBranchId])

    return <FormContext.Provider value={{ brand, currentBranch, setCurrentBranch, theme }}>
        {children}
    </FormContext.Provider>
}


export function useCurrentBranch() {
    const context = useContext(FormContext)
    if (!context) {
        throw new Error('useCurrentBranch should be used inside a CurrentBranchProvider')
    }
    const { brand, currentBranch, setCurrentBranch, theme } = context
    return { brand, currentBranch, setCurrentBranch, theme }
}
